// §7.2 — `IndustryData.Industry` value space. Restaurants run the
// `Restaurant` profile in-store and `CardNotPresent` for web flows.

export const TRX_INDUSTRY_TYPES = [
  "CardNotPresent",
  "Retail",
  "Restaurant",
  "Hotel",
  "Supermarket",
  "Fuel",
] as const;

export type TrxIndustryType = (typeof TRX_INDUSTRY_TYPES)[number];
